// ConversationModel.js

export default class ConversationModel {
  constructor(data) {
    this.id = data?.id_conv || null;
    this.conversableId = data?.conversable_id || null;
    this.type = data?.conversable_type || null;
    this.lastMessageAt = data?.last_message_at || null;

    // messages (optionnel si backend les envoie)
    this.messages = data?.messages || [];
  }

  static fromSession(session) {
    return new ConversationModel(session?.conversation);
  }

  static fromData(data) {
    return new ConversationModel(data);
  }

  get hasConversation() {
    return !!this.id;
  }

  get formattedLastMessage() {
    if (!this.lastMessageAt) return "Aucun message";
    return new Date(this.lastMessageAt).toLocaleString();
  }

  // 🎯 message preview (dernier message)
  get lastMessage() {
    if (!this.messages?.length) return null;
    return this.messages[this.messages.length - 1];
  }

  // 🎯 format message simple UI
  formatMessage(msg) {
    return {
      id: msg?.id_msg,
      content: msg?.content || msg?.message,
      sender: msg?.sender?.nom_user || "Inconnu",
      date: msg?.created_at ? new Date(msg.created_at).toLocaleString() : null,
    };
  }

  // 🎯 messages formatés pour UI
  get formattedMessages() {
    return (this.messages || []).map((m) => this.formatMessage(m));
  }
}